/**
 * Mapping, welche Komponente in welcher Reihenfolge auf welcher Unterseite der Werk-Fomulars erscheint.
 * Sowie welche Properties der Werks in der Komponente verarbeitet werden.
 */
import { WorkFormPage, WorkProperty } from '../util/types';

export interface WorkPageComponentsMapping {
  [page: WorkFormPage]: WorkPageComponent[];
}

export interface WorkPageComponent {
  key: string;
  fields: WorkProperty[];
}

export const pageComponents: WorkPageComponentsMapping = {
  basic: [
    {key: 'form_subject', fields: ['form_subject']}, // formschlagwort
    {key: 'publication_status', fields: ['publication_status']}, // angaben zum publikationsstatus
    {key: 'version', fields: ['version']}, // publikationsversion
    {key: 'resource_type', fields: ['resource_type']}, // art der ressource
    {key: 'title', fields: ['title']}, // titel
    {key: 'subtitle', fields: ['subtitle']}, // untertitel
    {key: 'language', fields: ['work_languages']}, // sprache
    {key: 'title_supplement', fields: ['title_supplement']}, // ergänzungen zum titel
    {key: 'other_title', fields: ['work_other_titles']}, // anderer titel
    {key: 'subseries_title', fields: ['subseries_title']}, // unterreihe
    {key: 'title_abbreviation', fields: ['work_title_abbreviations']}, // titelabkürzung
    {key: 'edition', fields: ['edition']}, // auflage/ausgabe
    {key: 'dataversion', fields: ['data_version']}, // version
    {key: 'number_of_volumes', fields: ['numberofvolumes']}, // anzahl bände
    {key: 'issued', fields: ['issued']}, // erscheinungszeitpunkt
    {key: 'date', fields: ['work_date_types']}, // datum
    {key: 'place', fields: ['workplaces']}, // ort
    {key: 'publisher', fields: ['work_publishers']}, // verlag
    {key: 'number_of_pages', fields: ['numberofpages']}, // gesamtseitenzahl
    {key: 'size', fields: ['size']}, // größe/umfang
    {key: 'number', fields: ['number']}, // nummer
    {key: 'url', fields: ['urls']}, // url
    {key: 'format', fields: ['format']}, // format
    {key: 'medium', fields: ['medium']}, // medium
    {key: 'note', fields: ['note']}, // notiz/bemerkung
    {key: 'peer_reviewed', fields: ['peer_reviewed']}, // peer reviewed
  ],
  specific: [
    {key: 'publication_number', fields: ['publication_number']},
    {key: 'application_number', fields: ['application_number']},
    {key: 'application_country', fields: ['application_country']},
    {key: 'priority_patent_application', fields: ['priority_patent_application']},
    {key: 'priority_country', fields: ['priority_country']},
    {key: 'priority_number', fields: ['priority_number']},
    {key: 'grant_number', fields: ['grant_number']},
    {key: 'patent_family', fields: ['patent_family']},
    {key: 'patent_id', fields: ['patent_id', 'patenttype']},
    {key: 'geo_location', fields: ['work_geo_locations']},
  ],
  ids: [
    {key: 'external_id', fields: ['external_ids']},
    {key: 'related_identifier', fields: ['internal_related_identifiers', 'external_related_identifiers']},
  ],
  persons: [
    {key: 'person', fields: ['work_persons', 'work_person_others']},
  ],
  ispartof: [
    {key: 'is_part_of', fields: ['work_is_part_ofs']},
    {key: 'is_part_of_other', fields: ['work_is_part_of_others']},
  ],
  haspart: [
    {key: 'has_part', fields: ['has_part']},
  ],
  organisations: [
    {key: 'organisation', fields: ['work_organisations', 'work_organisation_others']},
  ],
  projects: [
    {key: 'project', fields: ['work_projects']},
    {key: 'project_other', fields: ['work_project_others']},
  ],
  events: [
    {key: 'event_name', fields: ['events']},
  ],
  content: [
    {key: 'keyword', fields: ['work_keywords']},
    {key: 'subject', fields: ['work_subjects']},
    {key: 'description', fields: ['work_descriptions']},
  ],
  administrative: [
    {key: 'id', fields: ['id']},
    {key: 'date_changed', fields: ['date_changed']},
    {key: 'date_created', fields: ['date_created']},
    {key: 'origin', fields: ['origin']},
    {key: 'deskman', fields: ['deskman']},
    {key: 'hidden', fields: ['hidden']},
    {key: 'editorial_status', fields: ['editorial_status']},
    {key: 'belong_to_organisation', fields: ['organisations']},
    {key: 'belong_to_project', fields: ['projects']},
    {key: 'funded', fields: ['admin_data_work_open_access']},
    {key: 'access_level', fields: ['admin_data_work_open_access']},
    {key: 'license', fields: ['license']}, // lizenz
    {key: 'license_text', fields: ['licensetext']}, // urheberrechtliche und nutzungsrechtliche informationen
    {key: 'license_management_status', fields: ['license_management_status']},
    {key: 'article_processing_charge', fields: ['admin_data_work_open_access']},
    {key: 'obligatory_delivery', fields: ['obligatory_delivery']},
    {key: 'orcid_sync', fields: ['admin_data_work_orcid_syncs']},
  ],
};
